<template>
  <div>
    <arrorImg bg="white"></arrorImg>
    <navBar title="绑定手机号" color="#ffffff"></navBar>
    <div class="book_phone">
      <div>
        <span :class="nameText">手机号：</span>
        <input
          class="phone_input"
          v-model="phone"
          @input="getPhone"
          placeholder="输入手机号"
        />
      </div>
      <div class="code_input">
        <span :class="nameText">验证码：</span>
        <input
          class="uni-input"
          maxlength="6"
          v-model="code"
          placeholder="输入验证码"
          @input="getCode"
        />
        <span class="code-btn" :class="btnCode" @click="sendVerification">{{
          btnVal
        }}</span>
      </div>
    </div>
    <div class="btn_phone" @click="bindPhone">
      <span :class="btnClass">绑定</span>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      phone: "",
      code: "",
      btnCode: "",
      btnClass: "",
      nameText:'',
      time: 60,
      timer: null,
      btnVal: "获取验证码",
      seria: "",
      isEntranceData: "",
      pageType: "",
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
 
    this.pageType = this.$route.query.pageType;
   
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.insertPageAccessData();
  
    } else {
      this.insertPageAccessData();
    }
    this.$commonApi.share();
  },
  onShow() {
    let pages = getCurrentPages(); // 获取当前打开过的页面路由数组
    if (pages.length >= 2) {
      let prevPage = pages[pages.length - 2]; //上一页页面实例
      if (this.pageType == "bookTask") {
        //判断页面是否是从任务页面进入
        prevPage.isReload = true;
      }
    }
  },
  methods: {
    insertPageAccessData() {
      var prevPage = "";
    if (this.pageType === "bookCity") {
        prevPage = "书城";
      }else if (this.pageType === "bookRecharge") {
        prevPage = "充值中心";
      }else if (this.pageType === "bookMine") {
        prevPage = "我的";
      }else if (this.pageType === "bookTask") {
        prevPage = "任务中心";
      }
      var params = {
        pageName: "绑定手机号",
        pageRemark: "上级页面:"+prevPage,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    getPhone() {
      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        this.btnCode = "active";
      }
    },
    getCode() {
      if (this.code.trim() && /^1[3456789]\d{9}$/.test(this.phone)) {
        this.btnClass = "active";
        this.nameText='text-active'
      }
    },
    sendVerification() {
      if (this.btnCode) {
        this.getSmsCode();
      }
    },
    getSmsCode() {
      var params = {
        phone: this.phone,
      };
      this.$api.getSmsCode(params).then((res) => {
        if (res.status == 1) {
          this.seria = res.message;
          this.time = 60;
          this.btnCode = "";
          this.timer = setInterval(() => {
            this.btnVal = this.time + "s";
            this.time--;
            if (this.time == 0) {
              clearInterval(this.timer);
              this.btnVal = "获取验证码";
              this.btnCode = "active";
            }
          }, 1000);
          Toast({
            message: res.message,
          });
        } else {
          Toast({
            message: res.message,
          });
        }
      });
    },
    bindPhone() {
      var params = {
        mobile: this.phone,
        authCode: this.code,
        seria: this.seria,
      };
      this.$api.bindUserMobile(params).then((res) => {
        if (res.status == 1) {
          Toast({
            message: res.message,
          });
          this.$router.go(-1);
          this.$base.setStorage("mobile", this.phone);
        } else {
          Toast({
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.book_phone {
  padding: 0 16px;
  border-top: 5px solid #f7f7f7;
  padding-top: calc(44px + env(safe-area-inset-top));
}

.phone_input {
  padding: 16px 0px;
  border: none;
  font-size: 14px;
  color: #333;
}

.code_input {
  display: flex;
  padding: 16px 0px;
  border-bottom: 2px solid #f7f7f7;
  border-top: 2px solid #f7f7f7;
  justify-content: space-between;
  font-size: 14px;
}
.code_input span {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.code_input .code-btn {
  border: 1px solid #aaaaaa;
  border-radius: 100px;
  font-size: 12px;
  width: 88px;
  text-align: center;

  color: #aaaaaa;
}
input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{
	color:#AAAAAA;
}

input:-moz-placeholder,textarea:-moz-placeholder{
	color:#AAAAAA;
}

input::-moz-placeholder,textarea::-moz-placeholder{
	color:#AAAAAA;
}
input:-ms-input-placeholder,textarea:-ms-input-placeholder{
	color:#AAAAAA;
}
.book_phone>div>span{
  color: #AAAAAA;
}
.book_phone>div>.text-active{
  color: #333333;
}
.code_input input {
  border: none;
  font-size: 14px;
}
.code_input span.active {
  border: 1px solid #de3b34;
  color: #de3b34;
}

.btn_phone {
  padding: 0px 16px;
  margin-top: 36px;
}

.btn_phone > span {
  background-color: #D8D8D8;
  border-radius: 100px;
  display: block;
  color: #aaaaaa;
  font-size: 14px;
  padding: 16px 0px;
  text-align: center;
}

.btn_phone > span.active {
  color: #ffffff;
  background-color: #de3b34;
}
</style>



// WEBPACK FOOTER //
// src/view/bookPhone/index.vue